module.exports = __webpack_public_path__ + "officialStatic/img/haierLogo.5af4214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/haierLogo.png
// module id = JPmx
// module chunks = 0